import { applicationApi } from '../../common/api';
import { UmkmCategory } from './types';

export const umkmCategoryApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUmkmCategories: builder.query<UmkmCategory[], void>({
      query: () => `umkm-category`,
      providesTags: [{ type: 'UmkmCategory', id: 'LIST' }],
    }),
    getUmkmCategory: builder.query<UmkmCategory, string>({
      query: (id) => `umkm-category/${id}`,
    }),
    createUmkmCategory: builder.mutation<UmkmCategory, any>({
      query: (body) => ({
        url: '/umkm-category',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'UmkmCategory', id: 'LIST' }],
    }),
    deleteUmkmCategory: builder.mutation<any, number>({
      query: (id) => ({
        url: `umkm-category/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'UmkmCategory', id: 'LIST' }],
    }),
    updateUmkmCategory: builder.mutation<UmkmCategory, any>({
      query: (body) => ({
        url: '/umkm-category',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'UmkmCategory', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetAllUmkmCategoriesQuery,
  useGetUmkmCategoryQuery,
  useCreateUmkmCategoryMutation,
  useDeleteUmkmCategoryMutation,
  useUpdateUmkmCategoryMutation,
} = umkmCategoryApi;
